var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCompartment = function SvgCompartment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 2.25V1.25C1.69772 1.25 1.25 1.69772 1.25 2.25H2.25ZM2.25 15.75H1.25C1.25 16.3023 1.69772 16.75 2.25 16.75V15.75ZM15.75 2.25H16.75C16.75 1.69772 16.3023 1.25 15.75 1.25V2.25ZM15.75 15.75V16.75C16.3023 16.75 16.75 16.3023 16.75 15.75H15.75ZM1.25 2.25V15.75H3.25V2.25H1.25ZM2.25 16.75H6.75V14.75H2.25V16.75ZM6.75 1.25H2.25V3.25H6.75V1.25ZM6.75 3.25H15.75V1.25H6.75V3.25ZM14.75 2.25V7.5H16.75V2.25H14.75ZM7.75 15.75V7.5H5.75V15.75H7.75ZM7.75 7.5V2.25H5.75V7.5H7.75ZM11.25 14.75H6.75V16.75H11.25V14.75ZM11.25 16.75H15.75V14.75H11.25V16.75ZM16.75 15.75V7.5H14.75V15.75H16.75ZM6.75 8.5H15.75V6.5H6.75V8.5Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompartment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/compartment.49fe5ef4.svg";
export { ForwardRef as ReactComponent };